import { render, staticRenderFns } from "./CancelProjectIcon.vue?vue&type=template&id=60c545bc"
import script from "./CancelProjectIcon.vue?vue&type=script&lang=js"
export * from "./CancelProjectIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports